import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { ModuleModel } from 'app/audit/models/module.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';

@Component({
    selector: 'app-audit-module-add',
    templateUrl: './audit-module-add.component.html',
    styleUrls: ['./audit-module-add.component.css']
})
export class AuditModuleAddComponent implements OnInit {
    errors: string[];
    auditTypes: AuditTypeModel[];
    modules: ModuleModel[];
    addModuleFrom: FormGroup;
    submitAttempt: boolean = false;
    @Input() auditId: string;
    @Input() isEditMode: boolean = false;
    @Output() auditModuleAdded: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private auditService: AuditService,
        private fb: FormBuilder,
		private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTypes();
        this.getModules();

        this.addModuleFrom = this.fb.group({
            auditId: [this.auditId],
            moduleId: ['', Validators.required],
            auditTypeId: ['', Validators.required],
            order: ['', Validators.required]
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    getModules(): void {
        this.auditService.getModules().subscribe(result => {
            this.modules = result;
        });
    }

    addModuleToAudit(): void {
        this.submitAttempt = true;
        if (this.addModuleFrom.valid) {
            const formValue = this.addModuleFrom.value;
            formValue.auditId = this.auditId;
            this.auditService.addModuleToAudit(formValue).subscribe(
                result => {
                    this.auditModuleAdded.emit(result);
                    this.submitAttempt = false;
                    this.addModuleFrom.reset();
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddModule(content) {
        this.modalService.open(content);
    }
}
